import { api } from "./index";

export interface IAlertaEspaco {
  clienteID: string;
  nomeCliente: string;
  unidade: string;
  capacidadeTotal: number;
  capacidadeLivre: number;
  percentualUso: number;
}

export interface IAlertaBackup {
  clienteID: string;
  nomeCliente: string;
  tarefaNome: string;
  dataHora: string;
  erro: string;
}

export interface IDashboardUnidades {
  faturamentoTotal: number;
  comissaoTotal: number;
  clientesAtivos: number;
  taxaSucessoConsolidada: number;
  alertasEspaco: IAlertaEspaco[];
  alertasBackup: IAlertaBackup[];
}

export interface IPlanoCliente {
  id: string;
  tipo: string;
  valorVenda: number;
  nomeBase: string;
  valorBase: number;
}

export interface IClienteUnidade {
  id: string;
  codigo: number;
  nome: string;
  email: string;
  capacidadeArmazenamentoGB: number;
  usadoGB: number;
  ultimoBackup: {
    dataHora: string;
    tamanhoGB: number;
  } | null;
  plano: IPlanoCliente | null;
  coldStorageAtivo?: boolean;
  coldStorageEndpoint?: string;
  coldStorageKey?: string;
  coldStorageSecret?: string;
  coldStorageBucket?: string;
  coldStorageRegion?: string;
}

export interface IPlanoBase {
  id: string;
  nome: string;
  capacidadeGb: number;
  precoBaseMensal: number;
  precoBaseAnual: number;
}

export interface IFaturaCliente {
  id: string;
  clienteID: string;
  planoContratadoClienteID: string;
  competencia: string;
  dataVencimento: string;
  valorVenda: number;
  valorBase: number;
  valorComissao: number;
  status: string;
  dataPagamento: string | null;
}

export interface IHardwareDisco {
  id: string;
  clienteID: string;
  unidade: string;
  capacidadeTotal: number;
  capacidadeLivre: number;
  percentualUso: number;
}

export interface ITarefaCliente {
  tarefaAgendadaID: string;
  id: string;
  clienteID: string;
  nome: string;
  grupo: string;
  tipo: string;
  status: string;
  tipoAgendamento: string;
  horaExecucao: string;
  ultimaExecucao: {
    dataHora: string;
    status: string;
    tamanhoFinalBytes: number;
  } | null;
  proximaExecucao: {
    dataHora: string;
  } | null;
}

export class UnidadesApi {
  static async getDashboard(): Promise<IDashboardUnidades> {
    const response = await api.get<IDashboardUnidades>("/v2/unidades/dashboard");
    return response.data;
  }

  static async getClientes(): Promise<IClienteUnidade[]> {
    const response = await api.get<IClienteUnidade[]>("/v2/unidades/clientes");
    return response.data;
  }

  static async getPlanosBase(): Promise<IPlanoBase[]> {
    const response = await api.get<IPlanoBase[]>("/v2/unidades/planos-base");
    return response.data;
  }

  static async cadastrarClienteSimplificado(dados: any): Promise<any> {
    const response = await api.post("/v2/unidades/clientes/simplificado", dados);
    return response.data;
  }

  static async getHardwareCliente(clienteID: string): Promise<IHardwareDisco[]> {
    const response = await api.get<IHardwareDisco[]>(`/v2/unidades/clientes/${clienteID}/hardware`);
    return response.data;
  }

  static async getFaturasCliente(clienteID: string): Promise<IFaturaCliente[]> {
    const response = await api.get<IFaturaCliente[]>(`/v2/unidades/clientes/${clienteID}/faturas`);
    return response.data;
  }

  static async pagarFaturaSimulada(faturaID: string): Promise<any> {
    const response = await api.post(`/v2/unidades/faturas/${faturaID}/pagar-simulado`);
    return response.data;
  }

  static async getTarefasCliente(clienteID: string): Promise<{ items: ITarefaCliente[], total: number }> {
    const response = await api.get<{ items: ITarefaCliente[], total: number }>(`/v2/unidades/clientes/${clienteID}/tarefas`);
    return response.data;
  }

  static async criarTarefaCliente(clienteID: string, dados: any): Promise<any> {
    const response = await api.post(`/v2/unidades/clientes/${clienteID}/tarefas`, dados);
    return response.data;
  }

  static async carregarTarefaCliente(clienteID: string, tarefaID: string): Promise<any> {
    const response = await api.get(`/v2/unidades/clientes/${clienteID}/tarefas/${tarefaID}`);
    return response.data;
  }

  static async alterarTarefaCliente(clienteID: string, tarefaID: string, dados: any): Promise<any> {
    const response = await api.put(`/v2/unidades/clientes/${clienteID}/tarefas/${tarefaID}`, dados);
    return response.data;
  }

  static async alterarStatusTarefaCliente(clienteID: string, tarefaID: string, status: string): Promise<any> {
    const response = await api.patch(`/v2/unidades/clientes/${clienteID}/tarefas/${tarefaID}/status`, { status });
    return response.data;
  }

  static async salvarColdStorage(clienteID: string, dados: any): Promise<any> {
    const response = await api.put(`/v2/unidades/clientes/${clienteID}/cold-storage`, dados);
    return response.data;
  }
}
